module.exports = __webpack_public_path__ + "media/images/login/join_guide-ef66cad0f3e19530c8ad559303d87927.png";